import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import Dialog from './Dialog';
import PaymentsList from './../payment/PaymentsList';

class DialogPayments extends React.Component {

  render () {
    const { classes, open, onClose, fullScreen, keepMounted, ...others } = this.props;
    const id = "dialog-payments";
    return (
      <Dialog
        keepMounted={keepMounted}
        id={id}
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        title="Paiements"
      >
        <PaymentsList
          scrollableTarget={id}
          hideTitle={true}
          {...others}
        />
      </Dialog>
    )
  }
}

const styles = theme => ({});

DialogPayments.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogPayments);
